import ListTransactionPresenter from "../transactions/ListTransaction/ListTransaction"
import WalletInfo from "./WalletInfo/WalletInfo"
import WalletsActionBtnPresenter from "./WalletsActionBtn/WalletsActionBtn"



export const SingleWallet = {
    Info: WalletInfo,
    WalletActionBtn: WalletsActionBtnPresenter,
    TransactionList: ListTransactionPresenter

}

export default SingleWallet

